import React, { useEffect } from 'react';

interface QRCodeModalProps {
    qrCodeUrl: string;
    onClose: () => void;
}

const QRCodeModal: React.FC<QRCodeModalProps> = ({ qrCodeUrl, onClose }) => {
    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    return (
        <div
            onClick={onClose}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2000,
                padding: '20px',
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    padding: '30px',
                    maxWidth: '400px',
                    width: '100%',
                    position: 'relative',
                    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
                }}
            >
                {/* Close button */}
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '15px',
                        right: '15px',
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#999',
                        lineHeight: 1,
                        padding: '5px',
                    }}
                    aria-label="Zavrieť"
                >
                    ×
                </button>

                {/* QR Code */}
                <div style={{ textAlign: 'center' }}>
                    <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#333' }}>
                        QR kód bločku
                    </h3>
                    <img
                        src={qrCodeUrl}
                        alt="QR kód bločku"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            border: '1px solid #eee',
                            borderRadius: '8px',
                            padding: '10px',
                            backgroundColor: '#fafafa',
                        }}
                    />
                    <p style={{ marginTop: '15px', fontSize: '12px', color: '#666' }}>
                        Naskenujte tento QR kód pre zobrazenie bločku v eKasa systéme
                    </p>
                </div>
            </div>
        </div>
    );
};

export default QRCodeModal;
